import React from 'react'
import { Switch, Route, } from "react-router-dom";
import PublicView from 'views/public-views'

export const AuthLayout = () => {
	return (
		<div className="auth-container">
			<Switch>
				<Route path="" component={PublicView} />
			</Switch>
		</div>
	)
}


export default AuthLayout
